export default __webpack_public_path__ + "static/media/ic_svc_themes.7dd1cae1.png";